export default __webpack_public_path__ + "static/media/whylogo1.e48607d8.png";